__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2025-12-18-1766054904-stable-dev/";